import React, { Component, Fragment } from "react";
import Row from "../../containers/row";
import TwoCol from "../../containers/twoCol";
import ThreeCol from "../../containers/threeCol";
import FourCol from "../../containers/fourCol";
import Button from "../../button";
import Arrow from "../../assets/images/arrow-rule-left1.png";
import Gutters from "../../config/gutters";
import gutter from "../../config/vars";

class ButtonRow extends Component {
  returnButtons(token) {
    const buttons = this.props.row.field_row_content[0].field_4links_1;
    const buttonClass = this.props.row.field_row_content[0].field_button_style
      .name;
    let bgi = "url(" + Arrow + ")";
    let bgr = "no-repeat";
    let bgs = "45px 45px";
    let bgp = "right";
    if (
      this.props.row.field_row_content[0].field_button_style.attributes
        .field_boolean_1 === "0"
    ) {
      bgi = "none";
      bgr = "no-repeat";
      bgs = "";
      bgp = "";
    }

    const length = Array.isArray(buttons) ? buttons.length : 1;

    switch (length) {
      case 1:
        return (
          <Fragment>
            <TwoCol>
              <Button
                id={"item" + this.props.item + "_button1"}
                url={buttons.url}
                className={buttonClass}
                bgi={bgi}
                bgr={bgr}
                bgs={bgs}
                bgp={bgp}
              >
                {buttons.title}
              </Button>
            </TwoCol>
            <TwoCol>
              <p>&nbsp;</p>
            </TwoCol>
          </Fragment>
        );
      case 2:
        return buttons.map((button, i) => (
          <TwoCol key={i}>
            <Button
              styles={{ margin: "36px auto 0" }}
              id={"item" + this.props.item + "_button" + i}
              url={button.url}
              className={buttonClass}
              bgi={bgi}
              bgr={bgr}
              bgs={bgs}
              bgp={bgp}
            >
              {button.title}
            </Button>
          </TwoCol>
        ));
      case 3:
        return buttons.map((button, i) => (
          <ThreeCol styles={{ padding: "0", display: "inline-block" }} key={i}>
            <Button
              styles={{ margin: "36px auto 0" }}
              id={"item" + this.props.item + "_button" + i}
              url={button.url}
              className={buttonClass}
              bgi={bgi}
              bgr={bgr}
              bgs={bgs}
              bgp={bgp}
            >
              {button.title}
            </Button>
          </ThreeCol>
        ));
      case 4:
        return buttons.map((button, i) => (
          <FourCol styles={{ padding: 0, display: "inline-block" }} key={i}>
            <Button
              styles={{ margin: "36px auto 0" }}
              id={"item" + this.props.item + "_button" + i}
              url={button.url}
              className={buttonClass}
              bgi={bgi}
              bgr={bgr}
              bgs={bgs}
              bgp={bgp}
            >
              {button.title}
            </Button>
          </FourCol>
        ));
      default:
        return (
          <Fragment>
            <TwoCol>
              <p>Buttons Row no data</p>
            </TwoCol>
            <TwoCol>
              <p>Also Buttons Row no data</p>
            </TwoCol>
          </Fragment>
        );
    }
  }

  render() {
    const margin =
      Gutters.spacings[this.props.blockStyle.top] +
      "px 0px " +
      Gutters.spacings[this.props.blockStyle.btm] +
      "px 0px";
    const padding =
      Gutters.spacings[this.props.blockStyle.inner_top] +
      "px " +
      gutter +
      " " +
      Gutters.spacings[this.props.blockStyle.inner_btm] +
      "px " +
      gutter;
    return (
      <Row className="actionItems" margin={margin} padding={padding}>
        {this.returnButtons(this.props.token)}
      </Row>
    );
  }
}

export default ButtonRow;
